import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  IRutaCriticaProcesoRequest,
  IRutaCriticaProcesoResponse,
  IRutaCriticaProceso,
  IGuardarRutaCriticaProcesoRequest,
  IGuardarRutaCriticaProcesoResponse,
  IEditarRutaCriticaProcesoRequest,
  IEditarRutaCriticaProcesoResponse,
  IGetRutasRequest,
  IGetRutasResponse,
  IGetActividadesRequest,
  IGetActividadesResponse,
  IGetUsuariosRequest,
  IGetUsuariosResponse,
  IGuardarActividadRequest,
  IGuardarActividadResponse,
  IGetCatChkLsRequest,
  IGetCatChkLsResponse,
  IGetCuestionariosRequest,
  IGetCuestionariosResponse,
  IGetCatalogodocRequest,
  IGetCatalogodocResponse,
  IGetPantVarRequest,
  IGetPantVarResponse,
  IGetPerfilesRequest,
  IGetPerfilesResponse,
  IGetVariablesRequest,
  IGetVariablesResponse,
  IGetReportesRequest,
  IGetReportesResponse,
  IEditarActividadRequest,
  IEditarActividadResponse
} from '../interfaces/ruta-critica.interface';

interface IGuardarRutaRequest {
  que: number;
  tope: string;
  proceso: number;
  origen: number;
  destino: number;
  decision: string;
  correcta: number;
}

interface IGuardarRutaResponse {
  success: boolean;
  data: {
    error: string;
  };
}

interface IEliminarRutaRequest {
  que: number;
  tope: string;
  proceso: number;
  origen: number;
  destino: number;
  decision: string;
  correcta: number;
}

interface IAuditarRutaRequest {
  ruta: number;
}

interface IAuditarRutaResponse {
  success: boolean;
  data: {
    error: string;
  };
}

interface IEliminarActividadRequest {
  que: number;
  numeroProceso: number;
  numeroActividad: number;
  descripcion: string;
  tipoActividad: string;
  dependencia: string;
  tiempoEstimado: number;
  diasSemana: string;
  horas: number;
  minutos: number;
  horasDia: string;
  costoEstimado: number;
  marcajeAutomatico: string;
  envioCarta: string;
  procesoAutomatico: string;
  cuentaCredito: string;
  accion: string;
  resultado: string;
  responsable: string;
  carta: string;
  encuesta: string;
  decisiones: string;
}

interface IEliminarActividadResponse {
  success: boolean;
  data: {
    error: string;
  };
}

interface ICopiarProcesoRequest {
  que: number;
  numero_proceso: number;
  descripcion: string;
  descriptivo: string;
  duracion: number;
  costo: number;
}

interface ICopiarProcesoResponse {
  success: boolean;
  data: {
    error: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class RutaCriticaService {
  private apiUrl = `${environment.apiNewBackBaseUrl}`;

  constructor(private http: HttpClient) {}

  getProcesos(): Observable<IRutaCriticaProcesoResponse> {
    const request: IRutaCriticaProcesoRequest = {
      Numero_Proceso: 0,
      descripcion: '',
      descriptivo: '',
      duracion: 0,
      costo: 0
    };
    return this.http.post<IRutaCriticaProcesoResponse>(`${this.apiUrl}RutaCritica/Procesos`, request);
  }

  guardarProceso(request: IGuardarRutaCriticaProcesoRequest): Observable<IGuardarRutaCriticaProcesoResponse> {
    return this.http.post<IGuardarRutaCriticaProcesoResponse>(`${this.apiUrl}RutaCritica/GetProcesos1`, request);
  }

  getProcesoVar(request: IEditarRutaCriticaProcesoRequest): Observable<IEditarRutaCriticaProcesoResponse> {
    return this.http.post<IEditarRutaCriticaProcesoResponse>(`${this.apiUrl}RutaCritica/GetProcesosVar`, request);
  }

  eliminarProceso(numero_proceso: number): Observable<IGuardarRutaCriticaProcesoResponse> {
    const payload: IGuardarRutaCriticaProcesoRequest = {
      que: 3,
      numero_proceso,
      descripcion: '',
      descriptivo: '',
      duracion: 0,
      costo: 0
    };
    return this.http.post<IGuardarRutaCriticaProcesoResponse>(`${this.apiUrl}RutaCritica/GetProcesos1`, payload);
  }

  getRutas(request: IGetRutasRequest): Observable<IGetRutasResponse> {
    return this.http.post<IGetRutasResponse>(`${this.apiUrl}RutaCritica/GetRtavar`, request);
  }

  getActividades(request: IGetActividadesRequest): Observable<IGetActividadesResponse> {
    return this.http.post<IGetActividadesResponse>(`${this.apiUrl}RutaCritica/GetactividVAR`, request);
  }

  guardarRuta(request: IGuardarRutaRequest): Observable<IGuardarRutaResponse> {
    return this.http.post<IGuardarRutaResponse>(`${this.apiUrl}RutaCritica/GetRtaerr`, request);
  }

  eliminarRuta(request: IEliminarRutaRequest): Observable<IGuardarRutaResponse> {
    return this.http.post<IGuardarRutaResponse>(`${this.apiUrl}RutaCritica/GetRtaerr`, request);
  }

  auditarRuta(request: IAuditarRutaRequest): Observable<IAuditarRutaResponse> {
    return this.http.post<IAuditarRutaResponse>(`${this.apiUrl}RutaCritica/GetAudiRta`, request);
  }

  eliminarActividad(request: IEliminarActividadRequest): Observable<IEliminarActividadResponse> {
    return this.http.post<IEliminarActividadResponse>(`${this.apiUrl}RutaCritica/GetactividVerr2`, request);
  }

  copiarProceso(request: ICopiarProcesoRequest) {
    return this.http.post<ICopiarProcesoResponse>(`${this.apiUrl}RutaCritica/GetProcesos1`, request);
  }

  getUsuarios(request: IGetUsuariosRequest): Observable<IGetUsuariosResponse> {
    return this.http.post<IGetUsuariosResponse>(`${this.apiUrl}UsuarsCS/Getcmspa_usua4`, request);
  }

  getOpcionesDependencia(request: any) {
    return this.http.post<any>(`${this.apiUrl}OpcionesSolicitud/GetOpcionesVariables`, request);
  }

  getMotivosAutorizada(request: any) {
    return this.http.post<any>(`${this.apiUrl}Estatus/MotivosConsultaTipo`, request);
  }

  guardarActividad(request: IGuardarActividadRequest) {
    return this.http.post<IGuardarActividadResponse>(`${this.apiUrl}RutaCritica/GetactividVerr`, request);
  }

  getCatChkLs(request: IGetCatChkLsRequest) {
    return this.http.post<IGetCatChkLsResponse>(`${this.apiUrl}RutaCritica/GetCatChkLs`, request);
  }

  getCuestionarios(request: IGetCuestionariosRequest) {
    return this.http.post<IGetCuestionariosResponse>(`${this.apiUrl}Cuestionarios/cmspa_cuestionarioList`, request);
  }

  getCatalogodoc(request: IGetCatalogodocRequest) {
    return this.http.post<IGetCatalogodocResponse>(`${this.apiUrl}RutaCritica/GetCatalogodoc`, request);
  }

  getPantVar(request: IGetPantVarRequest) {
    return this.http.post<IGetPantVarResponse>(`${this.apiUrl}Solicitudes/Getpantvar4`, request);
  }

  getPerfiles(request: IGetPerfilesRequest) {
    return this.http.post<IGetPerfilesResponse>(`${this.apiUrl}RutaCritica/GetPerfl4`, request);
  }

  getVariables(request: IGetVariablesRequest) {
    return this.http.post<IGetVariablesResponse>(`${this.apiUrl}RutaCritica/GetVarble4`, request);
  }

  getReportesList(request: IGetReportesRequest): Observable<IGetReportesResponse> {
    return this.http.post<IGetReportesResponse>(`${this.apiUrl}Reportes/cmspa_cmtbl_ReportesList`, request);
  }

  getActivi5(request: any) {
    return this.http.post<any>(`${this.apiUrl}RutaCritica/Getactivi5`, request);
  }

  getactividVerr2(request: IEditarActividadRequest) {
    return this.http.post<IEditarActividadResponse>(`${this.apiUrl}RutaCritica/GetactividVerr2`, request);
  }
} 